// extracted by mini-css-extract-plugin
export default {"tileFrame":"MyWashPromoV2_tileFrame__1cYpB","dialogPaper":"MyWashPromoV2_dialogPaper__VMpv1","dialogFrame":"MyWashPromoV2_dialogFrame__UFG8g"};